import Avatar from '@components/avatar';
import { useSuiNSName } from '@hooks/use-sui-ns-name';
import { globalSettingModel } from '@models/global-setting.model';
import { bigNumberToReadable } from '@utils/big-number-to-readable';
import type { OpenapiClientPump } from 'src/openapi/pump';
import { type FC } from 'react';
import { Link } from 'react-router-dom';
import { Decimal } from 'turbos-clmm-sdk';
import styles from './list.module.scss';

interface OwnerProps {
  item: OpenapiClientPump.GetTokenCoinsHoldersResponse[number];
  pool: OpenapiClientPump.GetPoolsByTokenAddressResponse;
}

const List: FC<OwnerProps> = ({ item, pool }) => {
  const suiNames = useSuiNSName(item.wallet_address);
  const isCreated = pool.created_by === item.wallet_address;
  return (
    <li key={item.wallet_address}>
      <div className={styles.holder}>
        <Avatar address={item.wallet_address} />
        <Link to={globalSettingModel.explorerUrlForAccount(item.wallet_address)} target="_blank">
          {suiNames || item.wallet_address.slice(item.wallet_address.length - 8)}{' '}
          {isCreated ? '(Creator)' : ''}
        </Link>
      </div>
      <div>
        {bigNumberToReadable(new Decimal(item.percentage).mul(100).toString(), 0, false, 2)}%
      </div>
    </li>
  );
};

export default List;
